import { useEffect, useState, ReactNode } from "react"
import { useLocation } from "react-router-dom"
import { initializeAnalytics, trackPageView } from "../../lib/analytics"

interface AnalyticsProviderProps {
  children: ReactNode
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps): ReactNode {
  const location = useLocation()
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    void initializeAnalytics().then(() => {
      setInitialized(true)
    })
  }, [])

  useEffect(() => {
    if (!initialized) {
      return
    }

    const pagePath = location.pathname + location.search
    trackPageView(pagePath, document.title)
  }, [location, initialized])

  return children
}
